// extracted by mini-css-extract-plugin
export var attachmentContainer = "_sa-0";
export var fileList = "_sa-2";
export var removeFileButton = "_sa-1";